var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollRightButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.157 7.71089L1.5 13.3679L0.0859985 11.9539L5.036 7.00389L0.0859985 2.05389L1.5 0.639893L7.157 6.29689C7.34447 6.48442 7.44978 6.73873 7.44978 7.00389C7.44978 7.26906 7.34447 7.52337 7.157 7.71089Z",
    fill: "#C6C7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollRightButton);
export default __webpack_public_path__ + "static/media/scroll-right-button.c46ce97c3212c2d163c64834bffdd250.svg";
export { ForwardRef as ReactComponent };